module.exports = __webpack_public_path__ + "bfe4bf68.png";